import React, { useEffect, useRef } from "react";
import { Chart, registerables } from "chart.js";

// Register the necessary components
Chart.register(...registerables);

const DoughnutChart = (props) => {
    const { commissionBreakdownByTypeData, commissionBreakdownByTypeLabels, toDollarAmount } = props;
    const chartRef = useRef(null);

    useEffect(() => {
        const ctx = chartRef.current.getContext("2d");
        const doughnutChart = new Chart(ctx, {
            type: "doughnut",
            data: {
                datasets: [
                    {
                        label: commissionBreakdownByTypeLabels,
                        data: commissionBreakdownByTypeData,
                        backgroundColor: [
                            "rgba(224, 68, 3)", //km orange
                            "rgba(198, 178, 111)", //aztec gold? //todo
                            "rgba(151, 209, 220)", //harbor sky
                            "rgba(45, 135, 154)", //cosmic dust
                            "rgba(27, 16, 16)", //raven black
                            "rgba(95, 93, 94)", //ash
                            "rgba(175, 171, 172)", //sterling
                            "rgba(235, 238, 239)", //frost grey
                        ],
                    },
                ],
            },
            options: {
                legend: {
                    position: "right",
                    display: true,
                    generateLabels: function (chart) {
                        console.log("Chart", chart);
                        var data = chart.data;
                        console.log(data);
                        return [];
                    },
                },
                tooltips: {
                    callbacks: {
                        label: (tooltipItem, data) => {
                            const value = commissionBreakdownByTypeData[tooltipItem.index];
                            return toDollarAmount(value);
                        },
                    },
                },
            },
        });

        return () => {
            doughnutChart.destroy(); // Cleanup chart on component unmount
        };
    }, [commissionBreakdownByTypeData]);

    return <canvas ref={chartRef} />;
};

export default DoughnutChart;
